module.exports = __webpack_public_path__ + "img/2.df43740a.jpg";